<template>
  <modal name="my-modal">
    <div class="modal-content">
       <div v-html="formattedCGUText"></div>
      <b-button @click="accepteCGA">
        Accepter
      </b-button>
    </div>
  </modal>
</template>

<script>
import { mapState } from 'vuex'
import cguText from '../../assets/configuration/CGA.js'
export default {
  data () {
    return {
      cguText: cguText,
    }
  },
  computed: {
    ...mapState(['user']),
    formattedCGUText () {
      return this.cguText.replace(/\n/g, '<br>')
    },
  },
  methods: {
    accepteCGA () {
      // this.$modal.hide('my-modal'); // Pour fermer la fenêtre modale
      const url = window.location.href // Récupère l'URL de la page
      const parts = url.split('/')
      var user = this.user.name
      const id = parts[parts.length - 2]
      this.$store.dispatch('setCgaValue', {
        user: user,
        id: id,
        val: true
      })
      this.$emit('close-modal')
    },

  }
}
</script>

<style scoped>
.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
</style>
